// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { SECURITY_KEY } from "../../../globals";


// function Showservice() {
//   const [responseData, setResponseData] = useState([]);
//   const [filteredData, setFilteredData] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [recordsPerPage, setRecordsPerPage] = useState(10);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [deleteId, setDeleteId] = useState(null);
// //   const hiddenColumns = ["SomeHiddenColumn"];

//   const hiddenColumns = ["CompID", "ID", "ShortCode", "Deleted"];

//   const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;
//   const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

//   //  const API_URL = "http://localhost:5000/api/servicemast/get-services";
//   const API_URL = `${BASE_API_URL}/servicemast/get-services`;

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     setError(null);
//     setLoading(true);
//     setResponseData([]);

//     try {
//       const response = await fetch(API_URL, { method: "GET" });
//       const jsonData = await response.json();

//       if (jsonData.status && jsonData.data.length > 0) {
//         setResponseData(jsonData.data);
//         setFilteredData(jsonData.data);
//       } else {
//         setError("No data found.");
//       }
//     } catch (error) {
//       setError("Failed to fetch data. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const confirmDelete = (id) => {
//   setDeleteId(id); // store ID to delete
// };

// const handleDelete = async () => {
//   if (!deleteId) return;

//   const deleteData = new URLSearchParams();
//   // deleteData.append("SecurityKey", "abcd");
//   deleteData.append("SecurityKey", SECURITY_KEY);
//   deleteData.append("TableName", "ServiceMast");
//   deleteData.append("WhereCondition", `ID=${deleteId}`);
//   console.log(`ID=${deleteId}`);

//   // const deleteUrl = "https://etour.responseinfoway.com/restapi/deletedata.aspx";
//   // const deleteUrl = "https://etourrestapi.responseinfoway.com/restApi/deletedata.aspx";
//   const deleteUrl = `${BASE_REST_API_URL}/deletedata.aspx`;

//   try {
//     const response = await fetch(deleteUrl, {
//       method: "POST",
//       headers: { "Content-Type": "application/x-www-form-urlencoded" },
//       body: deleteData.toString(),
//     });

//     if (!response.ok) {
//       throw new Error(`API error! HTTP Status: ${response.status}`);
//     }

//     const textResponse = await response.text();
//     console.log("Delete Response:", textResponse);

//     // ✅ Match both ID types as strings
//     if (
//       textResponse.toLowerCase().includes("deleted") ||
//       textResponse.toLowerCase().includes("success") ||
//       textResponse.toLowerCase().includes("ok")
//     ) {
//       toast.success("Deleted successfully!");

//       setResponseData((prevData) =>
//         prevData.filter((item) => String(item.ID) !== String(deleteId))
//       );
//       setFilteredData((prevData) =>
//         prevData.filter((item) => String(item.ID) !== String(deleteId))
//       );
//     } else {
//       toast.error(`Delete failed: ${textResponse}`);
//     }
//   } catch (error) {
//     console.error("Delete Error:", error);
//     toast.error("Network error during deletion.");
//   } finally {
//     setDeleteId(null); // reset after delete
//   }
// };

//   const totalPages = Math.ceil(filteredData.length / recordsPerPage);
//   const indexOfLastRecord = currentPage * recordsPerPage;
//   const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
//   const currentRecords = filteredData.slice(
//     indexOfFirstRecord,
//     indexOfLastRecord
//   );

//   return (
//     <>
//       <div className="Payment_div">
//         <div className="payment_maintext">
//           <h6>ServiceMast</h6>

//           <div>
//             <Link className="payment_breadcrumbs" to={"/servisemaster"}>
//               <p>ServiceMast</p>
//             </Link>

//             <span>
//               <i className="fa-solid fa-chevron-right"></i>Master
//             </span>
//           </div>
//         </div>
//         <div className="button_search-payment">
//           <Link to={"/servisemaster"}>
//             <button type="button" className="btn btn">
//               <i className="fa-solid fa-plus"></i> Add ServiceMast
//             </button>
//           </Link>
//           <div className="search-input_box">
//             <input
//               type="search"
//               className="form-control"
//               placeholder="Search for name or designation..."
//               onChange={(e) => setSearchQuery(e.target.value)}
//             />
//           </div>
//         </div>

//         {/*  */}

//         <div className="vehicle-type-container mb-5">
//           <ToastContainer position="top-right" autoClose={3000} />


//             <div className="search-container mt-3">
//         <div className="records-per-page-container">
//           <label htmlFor="recordsPerPage">Records Per Page:</label>
//           <select
//             id="recordsPerPage"
//               value={recordsPerPage}
//               onChange={(e) => setRecordsPerPage(Number(e.target.value))}
//           >
//             <option value="5">5</option>
//             <option value="10">10</option>
//             <option value="15">15</option>
//             <option value="20">20</option>
//           </select>
//         </div>
//       </div>

//           {loading && <p>Loading...</p>}
//           {error && <p>{error}</p>}
          
// {!loading && currentRecords.length > 0 && (
//   <div className="response-container w-2/4">
//     <div className="table-wrapper">
//       <table className="data-table">
//         <thead>
//           <tr>
//             {Object.keys(currentRecords[0])
//               .filter((key) => !hiddenColumns.includes(key))
//               .map((key) => (
//                 <th key={key}>{key}</th>
//               ))}
//             <th className="w-14">Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {currentRecords.map((item, index) => (
//             <tr key={index}>
//               {Object.entries(item)
//                 .filter(([key]) => !hiddenColumns.includes(key))
//                 .map(([key, value], i) => (
//                   <td key={i}>
//                     {value !== null ? value.toString() : "N/A"}
//                   </td>
//                 ))}
//               <td>
//                 <div className="seletdata_edit-delet-btn">
//                   <Link
//                     to="/updateservice"
//                     state={{ responseData: item }}
//                   >
//                     <button className="selet_edit-btn" title="Edit">
//                       <i className="fa-solid fa-pen-to-square"></i>
//                     </button>
//                   </Link>
//                   <button
//                     className="select_delete-btn"
//                     data-bs-toggle="modal"
//                     data-bs-target="#deleteConfirmationModal"
//                     onClick={() => confirmDelete(item.ID)}
//                   >
//                     <i className="fa-solid fa-trash"></i>
//                   </button>
//                 </div>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>

//     {/* Pagination Controls */}
//     <div className="select_pagination mt-4">
//       <button
//         onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//         disabled={currentPage === 1}
//       >
//         Previous
//       </button>
//       <span>
//         &nbsp; {currentPage} of {totalPages}
//       </span>
//       <button
//         onClick={() =>
//           setCurrentPage((prev) => Math.min(prev + 1, totalPages))
//         }
//         disabled={currentPage === totalPages}
//       >
//         &nbsp; Next
//       </button>
//     </div>
//   </div>
// )}


//   {/* Delete Confirmation Modal */}
//       <div className="modal fade" id="deleteConfirmationModal">
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="close_topbutton-taxes">
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//               ></button>
//             </div>
//             <div className="delet_icon-boxtaxes">
//               <i className="fa-solid fa-trash"></i>
//             </div>
//             <div className="taxes_pcolom">
//               <h6>Confirm Delete</h6>
//               <p>Are you sure you want to delete?</p>
//             </div>
//             <div className="close_bottombutton-taxes">
//               <button
//                 type="button"
//                 className="btn btn-secondary"
//                 data-bs-dismiss="modal"
//               >
//                 Cancel
//               </button>
//               <button
//                 type="button"
//                 className="delete_button"
//                 data-bs-dismiss="modal"
//                 onClick={handleDelete}
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
  

         
//         </div>
//       </div>
//     </>
//   );
// }

// export default Showservice;




// here use the filter and base the company show the data

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { showToast } from "../../../utils/customToast";
import { SECURITY_KEY } from "../../../globals";
import { apiWithLog } from "../../../utils/apiWithLog";
import DeleteConfirmModal from "../../../Component/DeleteModal/DeleteConfirmModal";
import { MasterTableSkeleton } from "../../../Component/Skeleton";
import "../Ledger/ShowLedger.css";

function Showservice() {
  const [responseData, setResponseData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteItemName, setDeleteItemName] = useState("");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  // 🔹 NEW: track current company
  const [currentCompId, setCurrentCompId] = useState(null);

  const hiddenColumns = ["CompID", "ID", "ShortCode", "Deleted"];

  const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;
  const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

  /* ======================================================
     ✅ FETCH SERVICES COMPANY-WISE
  ====================================================== */
  const fetchData = async (compIdOverride = null) => {
    setError(null);
    setLoading(true);
    setResponseData([]);

    try {
      const company = JSON.parse(localStorage.getItem("selectedCompany"));
      const compId = compIdOverride || company?.id;

      if (!compId) {
        setError("Company not selected");
        setLoading(false);
        return;
      }

      const API_URL = `${BASE_API_URL}/servicemast/get-services/${compId}`;

      const response = await fetch(API_URL);
      const jsonData = await response.json();

      if (jsonData.status && Array.isArray(jsonData.data)) {
        setResponseData(jsonData.data);
        setFilteredData(jsonData.data);
      } else {
        setResponseData([]);
        setFilteredData([]);
        setError("No data found.");
      }
    } catch (error) {
      setError("Failed to fetch data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  /* ======================================================
     ✅ AUTO FETCH WHEN COMPANY CHANGES (NO REFRESH)
  ====================================================== */
  useEffect(() => {
    // Initial load
    const company = JSON.parse(localStorage.getItem("selectedCompany"));
    const compId = company?.id;

    if (compId) {
      setCurrentCompId(compId);
      fetchData(compId);
    }

    // 🔹 SAME TAB COMPANY CHANGE DETECTOR
    const interval = setInterval(() => {
      const latestCompany = JSON.parse(
        localStorage.getItem("selectedCompany")
      );
      const latestCompId = latestCompany?.id;

      if (latestCompId && latestCompId !== currentCompId) {
        setCurrentCompId(latestCompId);
        fetchData(latestCompId); // 🔥 AUTO LOAD
      }
    }, 300);

    return () => clearInterval(interval);
  }, [currentCompId]);

  /* ================= DELETE LOGIC ================= */
  const confirmDelete = (item) => {
    setDeleteId(item.ID);
    setDeleteItemName(item.Name || item.ServiceName || `Service #${item.ID}`);
    setDeleteModalOpen(true);
  };

  const handleDelete = async () => {
    if (isDeleting) return;
    if (!deleteId) return;

    const deleteData = new URLSearchParams();
    deleteData.append("SecurityKey", SECURITY_KEY);
    deleteData.append("TableName", "ServiceMast");
    deleteData.append("WhereCondition", `ID=${deleteId}`);

    const deleteUrl = `${BASE_REST_API_URL}/deletedata.aspx`;

    try {
      setIsDeleting(true);
      // ===== API with Logging =====
      const res = await apiWithLog({
        method: "POST",
        url: deleteUrl,
        data: deleteData.toString(),
        module: "ServiceMaster",
        action: "D",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      const textResponse =
        typeof res.data === "string"
          ? res.data
          : JSON.stringify(res.data);

      if (
        textResponse.toLowerCase().includes("deleted") ||
        textResponse.toLowerCase().includes("success") ||
        textResponse.toLowerCase().includes("ok")
      ) {
        showToast.delete("Service deleted successfully!");

        setResponseData((prev) =>
          prev.filter((item) => String(item.ID) !== String(deleteId))
        );

        setFilteredData((prev) =>
          prev.filter((item) => String(item.ID) !== String(deleteId))
        );
        setDeleteModalOpen(false);
      } else {
        showToast.error("Delete failed!");
      }
    } catch (error) {
      console.error("Service Delete Error:", error);
      showToast.error("Network error during deletion.");
    } finally {
      setIsDeleting(false);
      setDeleteId(null);
    }
  };

  /* ================= PAGINATION (UNCHANGED) ================= */
  const totalPages = Math.ceil(filteredData.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredData.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  return (
    <div className="ledger_page_container">
      {/* TOP HEADER & BREADCRUMBS */}
      <div className="ledger_header_bar">
        <div className="ledger_header_title_group">
          <h4 className="ledger_header_title">Service Master</h4>
          <div className="ledger_breadcrumbs">
            <Link to="/home">Home</Link>
            <span>/</span>
            <span>Master</span>
            <span>/</span>
            <span>Services</span>
          </div>
        </div>
      </div>

      {/* TOP CONTROLS CARD */}
      <div className="ledger_top_controls">
        <div className="ledger_top_left">
          <Link to="/servicemaster" className="new_ledger_btn">
            + Add Service
          </Link>
        </div>

        <div className="ledger_top_right">
          <div className="ledger_search_box">
            <input
              type="search"
              className="ledger_search_input"
              placeholder="Search services..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <div className="ledger_records_select_group">
            <label htmlFor="recordsPerPage">Show:</label>
            <select
              id="recordsPerPage"
              className="ledger_records_select"
              value={recordsPerPage}
              onChange={(e) => {
                setRecordsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </select>
          </div>
        </div>
      </div>

      {/* TABLE CARD */}
      <div className="ledger_table_section">
        {loading && (
          <MasterTableSkeleton columns={4} rows={6} hasToolbar={false} />
        )}

        {error && !loading && (
          <div className="ledger_empty_state">
            <h6>Error Loading Data</h6>
            <p>{error}</p>
          </div>
        )}

        {!loading && !error && currentRecords.length > 0 && (
          <>
            <div className="ledger_table_wrapper">
              <table className="ledger_table">
                <thead>
                  <tr>
                    {Object.keys(currentRecords[0])
                      .filter((key) => !hiddenColumns.includes(key))
                      .map((header) => (
                        <th key={header}>
                          {header === "ServiceName"
                            ? "Service Name"
                            : header === "HSNCODE"
                            ? "HSN Code"
                            : header === "TaxName"
                            ? "Tax Name"
                            : header === "TaxRate"
                            ? "Tax Rate (%)"
                            : header}
                        </th>
                      ))}
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentRecords.map((item, index) => (
                    <tr key={index}>
                      {Object.entries(item)
                        .filter(([key]) => !hiddenColumns.includes(key))
                        .map(([key, value], i) => (
                          <td
                            key={i}
                            className={key === "ServiceName" ? "ledger_name_cell" : ""}
                          >
                            {value !== null && value !== "" ? value.toString() : "-"}
                          </td>
                        ))}
                      <td className="ledger_actions_cell">
                        <Link
                          to="/updateservice"
                          state={{ responseData: item }}
                        >
                          <button
                            type="button"
                            className="ledger_btn_edit"
                            title="Edit Service"
                          >
                            <i className="fa-solid fa-pen-to-square"></i>
                          </button>
                        </Link>
                        <button
                          type="button"
                          className="ledger_btn_delete"
                          title="Delete Service"
                          onClick={() => confirmDelete(item)}
                        >
                          <i className="fa-solid fa-trash-can"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* PAGINATION SECTION */}
            <div className="ledger_pagination_container">
              <div className="ledger_pagination_info">
                Showing {indexOfFirstRecord + 1} to{" "}
                {Math.min(indexOfLastRecord, filteredData.length)} of{" "}
                {filteredData.length} records
              </div>

              <div className="ledger_pagination_controls">
                <button
                  type="button"
                  className="ledger_page_btn"
                  onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                <span className="ledger_page_badge">
                  Page {currentPage} of {totalPages || 1}
                </span>
                <button
                  type="button"
                  className="ledger_page_btn"
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  disabled={currentPage === totalPages || totalPages === 0}
                >
                  Next
                </button>
              </div>
            </div>
          </>
        )}

        {!loading && !error && currentRecords.length === 0 && (
          <div className="ledger_empty_state">
            <h6>No Services Found</h6>
            <p>
              {searchQuery
                ? `No services matching "${searchQuery}"`
                : "No services available."}
            </p>
          </div>
        )}
      </div>

      {/* Reusable Custom Delete Confirmation Modal */}
      <DeleteConfirmModal
        isOpen={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onConfirm={handleDelete}
        title="Delete Service?"
        message="Are you sure you want to delete this service?"
        itemName={deleteItemName}
        loading={isDeleting}
      />
    </div>
  );
}

export default Showservice;